/* tslint:disable */
/* eslint-disable */
/**
 * Payment API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ListCompanies200Response,
  ListOperations400Response,
  UpdateConditionsRequest,
} from '../models/index';
import {
    ListCompanies200ResponseFromJSON,
    ListCompanies200ResponseToJSON,
    ListOperations400ResponseFromJSON,
    ListOperations400ResponseToJSON,
    UpdateConditionsRequestFromJSON,
    UpdateConditionsRequestToJSON,
} from '../models/index';

export interface ListCompaniesRequest {
    page?: number;
    count?: number;
    sort?: ListCompaniesSortEnum;
    groupName?: string;
    companyName?: string;
    paymentGroupName?: string;
    serviceName?: string;
    expenseItemName?: string;
}

export interface UpdateConditionsOperationRequest {
    updateConditionsRequest: UpdateConditionsRequest;
}

/**
 * 
 */
export class CompaniesApi extends runtime.BaseAPI {

    /**
     * 会社設定一覧
     */
    async listCompaniesRaw(requestParameters: ListCompaniesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListCompanies200Response>> {
        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['count'] != null) {
            queryParameters['count'] = requestParameters['count'];
        }

        if (requestParameters['sort'] != null) {
            queryParameters['sort'] = requestParameters['sort'];
        }

        if (requestParameters['groupName'] != null) {
            queryParameters['group_name'] = requestParameters['groupName'];
        }

        if (requestParameters['companyName'] != null) {
            queryParameters['company_name'] = requestParameters['companyName'];
        }

        if (requestParameters['paymentGroupName'] != null) {
            queryParameters['payment_group_name'] = requestParameters['paymentGroupName'];
        }

        if (requestParameters['serviceName'] != null) {
            queryParameters['service_name'] = requestParameters['serviceName'];
        }

        if (requestParameters['expenseItemName'] != null) {
            queryParameters['expense_item_name'] = requestParameters['expenseItemName'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/companies`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListCompanies200ResponseFromJSON(jsonValue));
    }

    /**
     * 会社設定一覧
     */
    async listCompanies(requestParameters: ListCompaniesRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListCompanies200Response> {
        const response = await this.listCompaniesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 経済条件紐付け(一括)
     */
    async updateConditionsRaw(requestParameters: UpdateConditionsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['updateConditionsRequest'] == null) {
            throw new runtime.RequiredError(
                'updateConditionsRequest',
                'Required parameter "updateConditionsRequest" was null or undefined when calling updateConditions().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/companies/conditions`;

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateConditionsRequestToJSON(requestParameters['updateConditionsRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * 経済条件紐付け(一括)
     */
    async updateConditions(requestParameters: UpdateConditionsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateConditionsRaw(requestParameters, initOverrides);
    }

}

/**
 * @export
 */
export const ListCompaniesSortEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type ListCompaniesSortEnum = typeof ListCompaniesSortEnum[keyof typeof ListCompaniesSortEnum];
